"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Header = void 0;

var React = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _blocks = require("@bueno/blocks");

const Label = (0, _styledComponents.default)(_blocks.BodyLarge)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 64px;
  padding: 0 ${_blocks.spacing.loose};
  font-weight: ${_blocks.fontWeight.bold};
  cursor: pointer;
`;

const Header = ({
  label
}) => {
  const {
    toggleOpen,
    status
  } = (0, _blocks.useAccordion)();
  return /*#__PURE__*/React.createElement(Label, {
    onClick: toggleOpen
  }, /*#__PURE__*/React.createElement("span", null, label), status === 'open' || status === 'opening' ? /*#__PURE__*/React.createElement(_blocks.ArrowChevronUp, {
    small: true,
    fillColor: _blocks.color.pureBlack
  }) : /*#__PURE__*/React.createElement(_blocks.ArrowChevronDown, {
    small: true,
    fillColor: _blocks.color.pureBlack
  }));
};

exports.Header = Header;